import { createAction, props } from "@ngrx/store";
import { Recipient } from "../../models";

export const setRecipients = createAction('[Datalean Recipients] Set recipients', props<{ recipients: Recipient[] }>());
export const setErrorStatusRecipients = createAction('[Datalean Recipients] Set error status get recipients');

